import { render, staticRenderFns } from "./FinalReportVolunteers.vue?vue&type=template&id=9b60e80a&scoped=true&"
import script from "./FinalReportVolunteers.vue?vue&type=script&lang=js&"
export * from "./FinalReportVolunteers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b60e80a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VLayout})
